import { Button, Card, Divider, Input, Spin, Switch} from "antd";
import React, { useState } from "react";
import { utils } from "ethers";
import { SyncOutlined , GithubOutlined } from "@ant-design/icons";

import { Address, Balance, Events } from "../components";

export default function Home({
  bPDelegate,
  address,
  mainnetProvider,
//  localProvider,
//  yourLocalBalance,
  yourMainnetBalance,
  gasPrice,
  tx,
  readContracts,
  writeContracts,
}) {
const [amount, setAmount] = useState("0");
const queryParams = new URLSearchParams(window.location.search);
var validatorAddress = queryParams.get("VA");
var validatorName = queryParams.get("name");
if (validatorAddress === null) {
  var validatorAddress = "0x08c4596b157eafae5ec4e0fe629005bab2a10c3d"
}
if ( validatorName === null){
  var validatorName = "Maffaz.ONE"
}

  return (
    <div>
      {/*
        ⚙️ Here is an example UI that displays and sets the purpose in your smart contract:
      */}
      <div style={{ border: "1px solid #cccccc", padding: 16, width: 400, margin: "auto", marginTop: 8 }}>
       <h2>Delegate:</h2>
       <h4>Amount: {amount} ONE</h4>
        <Divider />
        <div style={{ margin: 8 }}>
          <Input placeholder="Input Amount > 100" style={{ "width":"80%" , "textAlign":"center" }}
            onChange={e => {
              setAmount(e.target.value);
            }}
          />
          <Button
            type={"primary"}
            style={{ marginTop: 8 }}
            onClick={async () => {
              /* look how you call setPurpose on your contract: */
              /* notice how you pass a call back for tx updates too */
              const amountONE = utils.parseEther(amount)
              const result = tx(writeContracts.bPStaking.bPDelegate( validatorAddress , amountONE), update => {
                console.log("📡 Transaction Update:", update);
                if (update && (update.status === "confirmed" || update.status === 1)) {
                  console.log(" 🍾 Transaction " + update.hash + " finished!");
                  console.log(
                    " ⛽️ " +
                      update.gasUsed +
                      "/" +
                      (update.gasLimit || update.gas) +
                      " @ " +
                      parseFloat(update.gasPrice) / 1000000000 +
                      " gwei",
                  );
                }
              });
              console.log("awaiting metamask/web3 confirm result...", result);
              console.log(await result);
            }}
          >
            Delegate to {validatorName}
          </Button>
        </div>
        {/*<Divider />
          Your Address: <span></span>
          <Address address={address}  ensProvider={mainnetProvider}  fontSize={16} /> */}
          <Divider />

          {/* use utils.formatEther to display a BigNumber: */}
          <h2>Balance: {yourMainnetBalance ? parseFloat(utils.formatEther(yourMainnetBalance)).toFixed(2) + " ONE" : "..."}</h2>
          <Divider />
          <a href="https://staking.harmony.one/welcome" target="_blank">Staking Portfolio</a>
          <Divider />
      </div>

      {/*
        📑 Maybe display a list of events?
          (uncomment the event and emit line in YourContract.sol! )
      */}
      <Events
        contracts={readContracts}
        contractName="bPStaking"
        eventName="StakingPrecompileCalled"

        mainnetProvider={mainnetProvider}
        startBlock={0}

      />
      <div>
        <Spin />
      </div>

      <div style={{ width: 600, margin: "auto", marginTop: 32, paddingBottom: 32 }}>
        <Card>
          Check out the{" "}
          <a
            href="https://github.com/bouncePassONE/labs/blob/main/contracts/bPStaking.sol"
            target="_blank"
            rel="noopener noreferrer"
          >
            contract <GithubOutlined /> code
          </a>
        </Card>


      </div>
    </div>
  );
}
